import each from 'lodash/each';
import PropTypes from 'prop-types';
import React from 'react';
import loadable from '@loadable/component';
import SanityBlockContent from '@sanity/block-content-to-react';

import Link from 'molecules/Link';

//import { lazy } from 'lib/helpers';
import VideoPlayer from 'molecules/VideoPlayer';
const Accordion = loadable( () => import( 'molecules/AccordionNew' ) );
const Image = loadable( () => import( 'molecules/Image' ) );
const GatedSignup = loadable( () => import( 'molecules/GatedSignup' ) );
const SplitCallout = loadable( () => import( 'molecules/SplitCallout' ) );
//const YouTube = loadable( () => import( 'molecules/YouTube' ) );


/**
 * Block Content.
 *
 * @param {array}     blocks.
 * @param {object}    placeholders. Optional.
 * @param {string}    primaryBreakpoint. Optional.
 */
const BlockContent = p => {

  // Basic placeholders.
  if( p.placeholders ) {

    let blockIndex = 0;
    for( let block of p.blocks ) {

      let childIndex = 0;
      for( let child of block.children ) {

        each( p.placeholders, ( replace, find ) => {
          child.text = child.text.replace( new RegExp( `${find}`, 'gi' ), replace );
        } );

        block.children[childIndex] = child;

        childIndex++;
      }

      p.blocks[blockIndex] = block;

      blockIndex++;

    }

  }

  // Serializers.
  const serializers = {
    marks: {
      link: ( { mark, children } ) => {

        const url = mark.url || mark.href;

        return(

          <Link
          to={ url }
          >
            { children }
          </Link>
        );

      },
      anchor: ( { _type, _key,  mark, children } ) => {

        const Tag = _type;

        return(
          <Tag id={ _key.substring( 0, 5 ) }>
            { children }
          </Tag>
        )
      }
    },
    types: {
      blockAccordion: ( { node } ) => {

        return(
          <Accordion
          type="listitem"
          size="sm"
          collapsed={ node.autoExpandOption }
          header={ () => (
            <>
              { !! node.preheading && <span className="prehding">{ node.preheading }</span> }
              <span className="hding">{ node.heading }</span>
              { !! node.subheading && <span className="subheading">{ node.subheading }</span> }
            </>
          ) }
          >
            <SanityBlockContent blocks={ node.content } />
          </Accordion>
        )
      },
      blockFancyList: ( { node } ) => {

        return(
          <ul className="dartlist">

            { !! node.items && node.items.map( ( { _key, item } ) => (

              <li
              key={ _key }
              >
                <SanityBlockContent blocks={ item } />
              </li>

            ) ) }

          </ul>
        )
      },
      blockGated: (  { node } ) => {

        return(
          <GatedSignup
          breakpoint="lg"
          { ...node }
          />
        )
      },
      blockQuote: ( { node } ) => {

        return(
          <div
          className="dartquote"
          >
            <blockquote>
              { node.quote }
              { !! node.name &&
                <cite>
                  { !! node.photo && <Image data={ node.photo.asset } /> }
                  <span className="name">{ node.name }</span>
                  { !! node.title && <>, <span className="title">{ node.title }</span></> }
                </cite>
              }
            </blockquote>
          </div>
        )
      },
      blockSplitCallout: ( { node } ) => {

        const props = { ...node }
        if( p.primaryBreakpoint ) {
          props.breakpoint = p.primaryBreakpoint;
        }

        return(
          <SplitCallout
          style={ {
            marginTop: '1.5rem',
            marginBottom: '1.5rem',
          } }
          { ...props }
          />
        )
      },
      blockSplitImage: ( { node } ) => <__BlockSplitImage { ...node } />,
      pageImage: ( { node } ) => {

        return(
          <Image
          data={ node.asset }
          alt={ node.alt }
          caption={ node.caption }
          />
        )
      },
      videoEmbed: ( { node } ) => {

        return(
          <VideoPlayer url={ node.url } />
        )
      }
    }
  }

  return(

    <SanityBlockContent
    className={ p.className }
    blocks={ p.blocks }
    serializers={ serializers }
    />

  )
}
export default BlockContent;

/* ------ = Subcomponents = --------------------------------------------------------------------- */

/**
 * Split image section.
 */
const __BlockSplitImage = node => (

  <div
  className="split-image row align-items-start"
  style={ {
    paddingTop: '1.5rem',
    paddingBottom: '1.5rem',
  } }
  >
    <div className={ `col-lg-${node.imageSize} ${node.imageSide === 'Right' ? 'order-lg-last' : '' }` }>
      <div>
        <Image
        data={ node.image.asset }
        alt={ node.image.alt }
        />
        { !! node.imageContent &&

          <div className="split-image__imgcontent">
            <BlockContent blocks={ node.imageContent } />
          </div>

        }
      </div>
    </div>
    <div className={ `col-lg-${12 - node.imageSize}` }>
      <BlockContent blocks={ node.content } />
    </div>
  </div>

)
